import { FunctionComponent, useEffect } from 'react';
import { Stack, FormControl, InputLabel, OutlinedInput, FormHelperText } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { DialogWrapper } from '../../presentation-components/display-elements-components/dialog-wrapper';
import MeasurementUnitService from '../../../shared/services/measurement-unit/measurement-unit.service';
import { IPostMeasurementUnit } from '../../../shared/services/measurement-unit/measurement-unit-model';

export const MeasurementUnitDialog: FunctionComponent<{
  open: boolean,
  closeHandler: () => void,
  isEdit: boolean,
  measurementUnitId?: string,
  isSubmitting: boolean,
  onSubmit: (values: IPostMeasurementUnit, resetForm: () => void, isEdit: boolean, measurementUnitId?: string) => void,
}> = ({
  open,
  closeHandler,
  isEdit,
  measurementUnitId,
  isSubmitting,
  onSubmit
}) => {
    //Service
    const measurementUnitService = new MeasurementUnitService()

    const measurementUnitSchema = Yup.object().shape({
      name: Yup.string().trim().required('Name is required'),
      description: Yup.string().nullable(),
    })
    const formik = useFormik<IPostMeasurementUnit>({
      validationSchema: measurementUnitSchema,
      enableReinitialize: false,
      initialValues: {
        name: '',
        description: '',
      },
      onSubmit: (values, { resetForm }) => {
        onSubmit(values, resetForm, isEdit, measurementUnitId)
      }
    })

    useEffect(() => {
      if (open && isEdit && measurementUnitId) {
        measurementUnitService.getOne(measurementUnitId)
          .then(response => {
            formik.setFieldValue('name', response.name)
            formik.setFieldValue('description', response.description)
          })
          .catch(() => { })
      }
    }, [open, isEdit, measurementUnitId])

    return (
      <DialogWrapper
        open={open}
        onClose={closeHandler}
        title={isEdit ? 'Edit Measurement Unit' : 'Add Measurement Unit'}
        cancelHandler={closeHandler}
        submitHandler={formik.submitForm}
        isSubmitting={isSubmitting}
        disableSaveButton={isSubmitting}
      >
        <Stack sx={{ mt: 1 }}>
          <FormControl fullWidth error={formik.touched.name && Boolean(formik.errors.name)}>
            <InputLabel htmlFor="name">Name</InputLabel>
            <OutlinedInput
              id="name"
              label="Name"
              value={formik.values.name || ''}
              onChange={(e) => formik.setFieldValue('name', e.target.value)}
            />
            <FormHelperText>
              {formik.touched.name && formik.errors.name ? formik.errors.name : ' '}
            </FormHelperText>
          </FormControl>
          <FormControl fullWidth error={formik.touched.description && Boolean(formik.errors.description)}>
            <InputLabel htmlFor="description">Additional Information</InputLabel>
            <OutlinedInput
              id="description"
              label="Additional Information"
              value={formik.values.description || ''}
              onChange={(e) => formik.setFieldValue('description', e.target.value)}
            />
            <FormHelperText>
              {formik.touched.description && formik.errors.description ? String(formik.errors.description) : ' '}
            </FormHelperText>
          </FormControl>
        </Stack>
      </DialogWrapper>
    )
  }


